angular.
module("dx.webapp.node").
controller("DxNodeExternalToolsController", function NodeExternalToolsController(
	$rootScope,
	$scope,
	$location,

	DX_URLS,
	dxApi,
	dxLocalize,
	dxSorting,
	DX_KEY_CODES
) {
	"use strict";

	var self = this;
	self.Urls = DX_URLS;
	self.nodeId = $scope.nodeId;

	self.externalToolsHelpUrl = dxLocalize.getLanguage() === "sv" ? "https://support.digiexam.se/hc/sv/articles/360017372879" :
		"https://digiexam.zendesk.com/hc/en-us/articles/360017372879";

	loadExternalTools();

	function loadExternalTools() {
		dxApi.v1.externalTools.list($scope.nodeId).then(function success(response) {
			self.externalTools = dxSorting.externalToolsSort(response.data);
		}, function fail() {
			$rootScope.$broadcast("notification:error", dxLocalize.get("ExternalTools.CouldNotLoadError.Plural"));
		});
	}

	self.navigateToEditTool = function navigateToEditTool(toolId) {
		$location.url(DX_URLS.get("externalToolEdit", {orgId: $scope.nodeId, id: toolId}));
	};

	self.onKeyDown = function onKeyDown(event, toolId) {
		if (event.keyCode === DX_KEY_CODES.enter) {
			self.navigateToEditTool(toolId);
		}
	};
});
